import React, {useState} from 'react';
import {styles} from './styles.web';
import {ButtonIconProps} from './ButtonIcon.types.web';
import {
  getButtonIconGeneralStyles,
  getButtonIconContentStyles,
  getIconSize,
  indicatorSizeMap,
} from './ButtonIcon.config.web';
import {useTheme} from '../../../../utils/theming/themeProvider';
import {IndicatorSize} from '../../Indicator/Indicator/indicator_types.web';
import Indicator from '../../Indicator/Indicator/indicator.web';
import CheckIcon from '../../Icons/icons/check';

const ButtonIcon = (props: React.PropsWithChildren<ButtonIconProps>) => {
  // Props
  const {
    id,
    className,
    color = 'grey',
    state = 'enable',
    style = 'square',
    size = 'medium',
    Icon = CheckIcon,
    iconColor,
    showStroke,
    showIndicator,
    indicator,
    containerStyle,
    onClick,
  } = props;

  // ButtonIcon Styles
  const {colors, fontStyles} = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  const currentState =
    state === 'enable' ? (isHovered ? 'hover' : 'enable') : state;

  const buttonStyles = getButtonIconGeneralStyles(
    colors,
    color,
    style,
    currentState,
    Icon,
    size,
    showStroke,
    onClick,
  );

  const buttonFontStyle = getButtonIconContentStyles(
    fontStyles,
    colors,
    color,
    currentState,
  );

  const dynamicIconColor = buttonFontStyle?.iconColor;
  const iconSize = getIconSize(Icon, size);
  const containerStyles = styles();

  return (
    <button
      id={id}
      className={className}
      onMouseEnter={() => setIsHovered(!!onClick)}
      onMouseLeave={() => setIsHovered(false)}
      //@ts-ignore
      style={{
        ...containerStyles?.buttonContainer,
        ...buttonStyles,
        ...containerStyle,
      }}
      onClick={state !== 'disable' ? onClick : undefined}>
      {Icon && (
        <Icon
          size={iconSize}
          color={iconColor || dynamicIconColor}
          style={'outline'}
        />
      )}
      {showIndicator && indicator ? (
        <Indicator
          id={indicator?.id}
          className={indicator?.className}
          size={indicatorSizeMap[size] as IndicatorSize}
          color={indicator.color || 'purple'}
          type={'quantity'}
          quantity={indicator.quantity || 0}
          containerStyle={{
            position: 'absolute',
            right: (0 - buttonStyles?.padding) / 4,
            top: (0 - buttonStyles?.padding) / 4,
          }}
        />
      ) : null}
    </button>
  );
};

export default ButtonIcon;
